import { Config } from '@retro-ui/config';
import { createContext } from 'react';

export interface ConfigContextInterface {
  config?: Config['global'];
}

export const ConfigContext = createContext<ConfigContextInterface | undefined>({ config: undefined });
